"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _inRange2 = _interopRequireDefault(require("lodash/inRange"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InfiniteList = _interopRequireDefault(require("../../../InfiniteList"));
var _excluded = ["children", "itemData", "itemSize", "hasNextPage"],
  _excluded2 = ["children"],
  _excluded3 = ["component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InfiniteListDefaultProps = _InfiniteList["default"].defaultProps,
  InfiniteListPropTypes = _InfiniteList["default"].propTypes;
var ITEM_SIZE = 105;
var STYLES = {
  MARGIN_RIGHT: 10,
  MARGIN_TOP: 12
};
var Context = /*#__PURE__*/_react["default"].createContext();
var InfiniteTabs = /*#__PURE__*/function (_React$PureComponent) {
  function InfiniteTabs(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, InfiniteTabs);
    _this = _callSuper(this, InfiniteTabs, [props]);
    var value = props.value;
    _this.state = {
      isStickyOnBottom: false,
      isStickyOnTop: false,
      prevPropValue: value,
      value: value
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleItemsRendered = _this.handleItemsRendered.bind(_this);
    _this.handleRefList = _this.handleRefList.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(InfiniteTabs, _React$PureComponent);
  return (0, _createClass2["default"])(InfiniteTabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setAndCheckSelectedTabElement();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setAndCheckSelectedTabElement();
    }

    /**
     * Метод ищет элемент выделенного таба и, если находит, то проверяет, должен ли он быть прикреплён
     * к верху или низу элемента контейнера компонента.
     */
  }, {
    key: "setAndCheckSelectedTabElement",
    value: function setAndCheckSelectedTabElement() {
      if (!this.el) {
        this.selectedTabEl = null;
        return;
      }
      var value = this.state.value;
      this.selectedTabEl = this.el.querySelector("li[value=\"".concat(value, "\"]:not([data-sticky=\"true\"])"));
      if (!this.selectedTabEl) {
        this.selectedTabEl = null;
        return;
      }
      this.selectedIndex = this.selectedTabEl.dataset.index;
      this.checkSticky();
    }

    /**
     * Метод определеляет, должен ли быть прикреплён элемент выделенного таба к верху или низу
     * элемента контейнера компонента.
     */
  }, {
    key: "checkSticky",
    value: function checkSticky() {
      if (!this.el || !this.selectedTabEl) {
        return;
      }
      var item = this.selectedTabEl;
      var itemRect = item.getBoundingClientRect();
      var list = this.el;
      var listRect = list.getBoundingClientRect();
      var height = itemRect.height,
        width = itemRect.width;
      if (height === 0 && width === 0) {
        return;
      }
      var listStyle = window.getComputedStyle(list);
      var listTopOffset = Number(listStyle.borderTopWidth.replace(/\D+/g, '')) + Number(listStyle.paddingTop.replace(/\D+/g, ''));
      var isStickyOnTop = list.scrollTop && itemRect.y - listTopOffset <= listRect.y;
      var isStickyOnBottom = false;
      if (!isStickyOnTop) {
        var isScrollBottom = list.scrollHeight - list.scrollTop !== list.clientHeight;
        var listBottomOffset = Number(listStyle.borderBottomWidth.replace(/\D+/g, '')) + Number(listStyle.paddingBottom.replace(/\D+/g, ''));
        var isSticky = itemRect.y >= listRect.y + list.offsetHeight - listBottomOffset - item.offsetHeight;
        isStickyOnBottom = isScrollBottom && isSticky;
      }
      this.setState({
        isStickyOnBottom: !!isStickyOnBottom,
        isStickyOnTop: !!isStickyOnTop
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this2 = this;
      var value = this.state.value;
      var tabElement = event.target.closest('li');
      var nextValue = tabElement.getAttribute('value');
      if (!nextValue || nextValue === value) {
        return;
      }
      var onSelect = this.props.onSelect;
      this.setState({
        value: nextValue
      }, function () {
        onSelect(nextValue);
        _this2.setAndCheckSelectedTabElement();
      });
    }

    /**
     * Метод следит за отображением выделенного таба в DOM-е, потому что таб может пропасть, а после
     * его появления нужно заново найти его элемент. Если выделенный таб не успел добавиться в DOM
     * (такое возможно, например, если очень быстро промотать список), то тогда определение позиции
     * залипания происходит при сравнении с индексами отображённых табов.
     */
  }, {
    key: "handleItemsRendered",
    value: function handleItemsRendered(_ref) {
      var overscanStartIndex = _ref.overscanStartIndex,
        overscanStopIndex = _ref.overscanStopIndex;
      if ((0, _inRange2["default"])(this.selectedIndex, overscanStartIndex, overscanStopIndex)) {
        this.setAndCheckSelectedTabElement();
      } else {
        this.setState({
          isStickyOnBottom: this.selectedIndex > overscanStopIndex,
          isStickyOnTop: this.selectedIndex < overscanStartIndex
        });
      }
    }
  }, {
    key: "handleRefList",
    value: function handleRefList(component) {
      this.el = _reactDom["default"].findDOMNode(component);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.checkSticky();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        child = _this$props.children,
        itemData = _this$props.itemData,
        itemSize = _this$props.itemSize,
        hasNextPage = _this$props.hasNextPage,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state = this.state,
        isStickyOnBottom = _this$state.isStickyOnBottom,
        isStickyOnTop = _this$state.isStickyOnTop,
        value = _this$state.value;
      return /*#__PURE__*/_react["default"].createElement(StyledInfiniteTabs, null, /*#__PURE__*/_react["default"].createElement(Context.Provider, {
        value: {
          child: child,
          containerEl: this.el,
          index: this.selectedIndex,
          isStickyOnBottom: isStickyOnBottom,
          isStickyOnTop: isStickyOnTop,
          itemData: itemData,
          itemSize: itemSize,
          value: value
        }
      }, /*#__PURE__*/_react["default"].createElement(StyledInfiniteList, (0, _extends2["default"])({}, props, {
        hasNextPage: hasNextPage,
        innerElementType: InfiniteTabs.getInnerElement,
        itemData: itemData,
        itemSize: itemSize + STYLES.MARGIN_TOP,
        onItemsRendered: this.handleItemsRendered,
        onScroll: this.handleScroll,
        ref: this.handleRefList
      }), function (_ref2) {
        var data = _ref2.data,
          index = _ref2.index,
          style = _ref2.style;
        var component = child({
          data: data,
          index: index,
          style: _objectSpread(_objectSpread({}, style), {}, {
            height: style.height - STYLES.MARGIN_TOP,
            right: STYLES.MARGIN_RIGHT
            // top: style.top + STYLES.MARGIN_TOP,
          })
        });
        if (!component) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(StyledTab, {
          "data-index": index,
          component: component,
          onClick: _this3.handleClick,
          selected: value === component.props.value
        });
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var propsValue = _ref3.value;
      var prevPropsValue = _ref4.prevPropsValue;
      if (propsValue === prevPropsValue) {
        return null;
      }
      return {
        prevPropsValue: propsValue,
        value: propsValue
      };
    }
  }, {
    key: "getInnerElement",
    value: function getInnerElement(_ref5) {
      var children = _ref5.children,
        props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
      return /*#__PURE__*/_react["default"].createElement(Context.Consumer, null, function (_ref6) {
        var child = _ref6.child,
          containerEl = _ref6.containerEl,
          index = _ref6.index,
          isStickyOnBottom = _ref6.isStickyOnBottom,
          isStickyOnTop = _ref6.isStickyOnTop,
          itemData = _ref6.itemData,
          itemSize = _ref6.itemSize,
          value = _ref6.value;
        var isSticky = isStickyOnBottom || isStickyOnTop;
        var containerSize = (0, _get2["default"])(containerEl, 'clientHeight') || 0;
        var stickyTab = null;
        if (isSticky) {
          var component = child({
            data: itemData,
            index: index,
            style: {
              height: itemSize,
              top: isStickyOnTop ? 0 : containerSize - itemSize
            }
          });
          if (component && value === component.props.value) {
            stickyTab = /*#__PURE__*/_react["default"].createElement(StyledTab, {
              component: component,
              selected: true,
              "data-sticky": isSticky,
              sticky: isSticky,
              stickyBottom: isStickyOnBottom,
              stickyTop: isStickyOnTop
            });
          }
        }
        return /*#__PURE__*/_react["default"].createElement(StyledTabs, props, stickyTab, children);
      });
    }
  }]);
}(_react["default"].PureComponent);
InfiniteTabs.propTypes = _objectSpread(_objectSpread({}, InfiniteListPropTypes), {}, {
  itemSize: _propTypes["default"].number,
  onSelect: _propTypes["default"].func,
  value: _propTypes["default"].string
});
InfiniteTabs.defaultProps = _objectSpread(_objectSpread({}, InfiniteListDefaultProps), {}, {
  itemSize: ITEM_SIZE,
  onSelect: Function.prototype,
  value: null
});
var StyledInfiniteTabs = _styledComponents["default"].div.withConfig({
  displayName: "InfiniteTabs__StyledInfiniteTabs",
  componentId: "sc-16ylcjn-0"
})(["height:100%;width:100%;"]);
var StyledInfiniteList = (0, _styledComponents["default"])(_InfiniteList["default"]).withConfig({
  displayName: "InfiniteTabs__StyledInfiniteList",
  componentId: "sc-16ylcjn-1"
})(["::-webkit-scrollbar{width:0;}"]);
var StyledTabs = _styledComponents["default"].ul.withConfig({
  displayName: "InfiniteTabs__StyledTabs",
  componentId: "sc-16ylcjn-2"
})(["border-radius:4px;position:relative;"]);
var StyledTab = (0, _styledComponents["default"])(function (_ref7) {
  var component = _ref7.component,
    props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded3);
  return /*#__PURE__*/_react["default"].cloneElement(component, props);
}).withConfig({
  displayName: "InfiniteTabs__StyledTab",
  componentId: "sc-16ylcjn-3"
})(["box-sizing:border-box;width:auto !important;> button{outline:none;text-align:left;}", " ", " ", " ", ""], function (_ref8) {
  var selected = _ref8.selected;
  return selected && "\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    padding-right: ".concat(STYLES.MARGIN_RIGHT, "px;\n    right: 0 !important;\n  ");
}, function (_ref9) {
  var sticky = _ref9.sticky;
  return sticky && "\n    position: sticky;\n    z-index: 2;\n  ";
}, function (_ref10) {
  var stickyTop = _ref10.stickyTop;
  return stickyTop && "\n    box-shadow: 0 -5px 0 0 #e6e6e6, \n                0 10px 15px 0 rgba(196, 194, 182, 0.9),\n                0 1px 2px 0 rgba(210, 208, 197, 0.9);\n  ";
}, function (_ref11) {
  var stickyBottom = _ref11.stickyBottom;
  return stickyBottom && "\n    box-shadow: 0 -10px 15px 0 rgba(196, 194, 182, 0.9),\n                0 -1px 2px 0 rgba(210, 208, 197, 0.9),\n                0 5px 0 0 #e6e6e6;\n  ";
});
var _default = exports["default"] = InfiniteTabs;